var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"post-details"},[_c('post',{attrs:{"post":_vm.postDetails,"details":true}}),_c('report-dialog',{attrs:{"post-id":_vm.postDetails.id,"dialog":_vm.dialogChange},on:{"onCloseDialog":_vm.closeReportDialog}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }